import React from 'react';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';
import { Route } from '../../../../utils/router';
import PageHeaderNav from '../../components/PageHeaderNav';
import { routes } from '../../routes';

type TabItem = {
  label: string;
  route: Route<string[]>;
};

export const WorkflowsNav: React.FC<React.PropsWithChildren<unknown>> = () => {
  const t = useNamespacedTranslation('workflows.tabs');

  const tabItems: TabItem[] = [
    {
      label: t('forAll'),
      route: routes.workflowsAll.route,
    },
    {
      label: t('forMe'),
      route: routes.workflowsMe.route,
    },
    {
      label: t('forOthers'),
      route: routes.workflowsOthers.route,
    },
  ];

  return <PageHeaderNav tabItems={tabItems} exact={false} />;
};
